import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentService } from '../services/paymentService';
import type {
  CreateSubscriptionRequest,
  UpdateSubscriptionRequest,
} from '../types/payments';
import { SUBSCRIPTION_KEYS, PAYMENT_KEYS, DUES_KEYS } from './queryKeys';

// User's subscription
export const useMySubscription = () => {
  return useQuery({
    queryKey: SUBSCRIPTION_KEYS.mine,
    queryFn: () => paymentService.getMySubscription(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

// Create subscription mutation
export const useCreateSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateSubscriptionRequest) => paymentService.createSubscription(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_KEYS.mine });
      queryClient.invalidateQueries({ queryKey: PAYMENT_KEYS.balance });
      queryClient.invalidateQueries({ queryKey: DUES_KEYS.all });
    },
  });
};

// Cancel subscription mutation
export const useCancelSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => paymentService.cancelSubscription(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_KEYS.mine });
      queryClient.invalidateQueries({ queryKey: PAYMENT_KEYS.balance });
      queryClient.invalidateQueries({ queryKey: DUES_KEYS.all });
    },
  });
};

// Update subscription frequency mutation
export const useUpdateSubscriptionFrequency = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateSubscriptionRequest }) =>
      paymentService.updateSubscriptionFrequency(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_KEYS.mine });
    },
  });
};
